import { Button } from '@heroui/react';
import { cn } from '@hs/ui';
import { IconHourglassHigh, IconStopwatch } from '@tabler/icons-react';
import type { FC } from 'react';

import type { TimerMode } from './types';

const ICON_STROKE = 1.25;

const MODE_META: Record<
  TimerMode,
  { Icon: typeof IconHourglassHigh; label: string }
> = {
  countDown: { Icon: IconHourglassHigh, label: '倒计时' },
  countUp: { Icon: IconStopwatch, label: '正计时' },
};

export type TimerModeToggleProps = {
  mode: TimerMode;
  editable: boolean;
  onToggle: () => void;
};

export const TimerModeToggle: FC<TimerModeToggleProps> = ({ mode, editable, onToggle }) => {
  const { Icon, label } = MODE_META[mode];

  if (!editable) {
    return (
      <span
        className="inline-flex shrink-0 text-muted-foreground"
        aria-label={label}
        title={label}
      >
        <Icon className="size-4" stroke={ICON_STROKE} />
      </span>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      isIconOnly
      aria-label={`切换计时模式，当前${label}`}
      className={cn('size-7 min-w-7 shrink-0 text-foreground')}
      onPress={onToggle}
    >
      <Icon className="size-4" stroke={ICON_STROKE} />
    </Button>
  );
};
